import { Injectable } from '@angular/core';
import { Rpfi09PosGroup, Rpfi09Row, Rpfi09TableResult, Rpfi09Totals } from '../../models/report/rpfi09.model';

@Injectable({ providedIn: 'root' })
export class MapperRpfi09Service {
  mapTable(res: unknown): Rpfi09TableResult {
    const raw = (res ?? {}) as Record<string, unknown>;
    const groups = (raw['groups'] ?? raw['Groups'] ?? []) as unknown[];
    return {
      siteName: String(raw['siteName'] ?? raw['SiteName'] ?? ''),
      siteAddress: String(raw['siteAddress'] ?? raw['SiteAddress'] ?? ''),
      siteTaxId: String(raw['siteTaxId'] ?? raw['SiteTaxId'] ?? ''),
      startDate: (raw['startDate'] ?? raw['StartDate'] ?? null) as string | null,
      endDate: (raw['endDate'] ?? raw['EndDate'] ?? null) as string | null,
      groups: groups.map((g) => this.mapGroup(g)),
      totals: this.mapTotals(raw['totals'] ?? raw['Totals'] ?? {}),
    };
  }

  private mapGroup(dto: unknown): Rpfi09PosGroup {
    const g = (dto ?? {}) as Record<string, unknown>;
    const rows = (g['rows'] ?? g['Rows'] ?? []) as unknown[];
    return {
      posName: String(g['posName'] ?? g['PosName'] ?? ''),
      rows: rows.map((r) => this.mapRow(r)),
      sumFee: Number(g['sumFee'] ?? g['SumFee'] ?? 0),
      sumVat: Number(g['sumVat'] ?? g['SumVat'] ?? 0),
      sumTotal: Number(g['sumTotal'] ?? g['SumTotal'] ?? 0),
    };
  }

  private mapRow(dto: unknown): Rpfi09Row {
    const r = (dto ?? {}) as Record<string, unknown>;
    return {
      seq: Number(r['seq'] ?? r['Seq'] ?? 0),
      paidDate: (r['paidDate'] ?? r['PaidDate'] ?? null) as string | null,
      posName: String(r['posName'] ?? r['PosName'] ?? ''),
      cashierName: String(r['cashierName'] ?? r['CashierName'] ?? ''),
      receiptId: String(r['receiptId'] ?? r['ReceiptId'] ?? ''),
      statusLabel: String(r['statusLabel'] ?? r['StatusLabel'] ?? ''),
      fee: Number(r['fee'] ?? r['Fee'] ?? 0),
      vat: Number(r['vat'] ?? r['Vat'] ?? 0),
      total: Number(r['total'] ?? r['Total'] ?? 0),
    };
  }

  private mapTotals(dto: unknown): Rpfi09Totals {
    const t = (dto ?? {}) as Record<string, unknown>;
    return {
      rowCount: Number(t['rowCount'] ?? t['RowCount'] ?? 0),
      sumFee: Number(t['sumFee'] ?? t['SumFee'] ?? 0),
      sumVat: Number(t['sumVat'] ?? t['SumVat'] ?? 0),
      sumTotal: Number(t['sumTotal'] ?? t['SumTotal'] ?? 0),
    };
  }
}
